import axios from "axios";

// L'origine de l'API se deduit a l'execution plutot qu'au build.
//
// Pourquoi : en developpement le front (port 3000) et l'API (port 8001) sont sur
// deux origines, en production ils partagent la meme. On a d'abord tente un
// .env.production, mais craco/react-scripts ne l'applique pas ici — le build
// embarquait « http://localhost:8001 » et la connexion echouait sur le site en
// ligne. Deduire l'origine du navigateur supprime le probleme, et un meme build
// devient valable sur n'importe quel domaine (utile pour installer l'outil chez
// plusieurs couvreurs sans recompiler).
const surLocalhost =
  typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1|\[::1\])$/i.test(window.location.hostname);

export const BACKEND_ORIGIN = surLocalhost
  ? process.env.REACT_APP_BACKEND_URL || "http://localhost:8001"
  : typeof window !== "undefined"
    ? window.location.origin
    : "";

export const API = `${BACKEND_ORIGIN}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
